import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { EnNavHeader } from './EnNavHeader';
import { EnNavFooter } from './EnNavFooter';

import { getClientId } from './utils/analyticsclientIdUtils';
import { encryptData } from './utils/encryptionUtils';

import { validatePassword, validateNameEN, validateLastnameEN } from './utils/validatePassword';

class EnAuthJoinDetail20Class extends Component {

    constructor(props) {
        super(props);

        this.otpInputRefs = [];

        this.state = {
            memberInfo: null,
            codeRegister: null,
            password1: '',
            password2: '',
            prefix: '',
            firstname: '',
            lastname: '',
            firstnameth: '',
            lastnameth: '',
            mobile: '',
            bdDay: '',
            bdMonth: '',
            agree1: false,
            agree2: false,
            registerMsg: '',
            registerMsgPwd: '',
            registerMsgPwd2: '',
            registerMsgFname: '',
            registerMsgLname: '',
            registerMsgMobile: '',
            submitting: false, // Add a state variable to track form submission status
            showPasswordTips: false,
            renderCheck: false,
            cssPopupBD: 'popuphide',
            currentStep: '1',//SR2.0 param start here
            disabledBtnOtp: true,
            disabledBtnSubmit: true,
            languagePreference: '',
            receiveNews: false,
            receiveNewsSMS: false,
            receiveNewsEmail: false,
            receiveNewsCss: 'mb-3 ps-0 d-none',
            showOtpModal: false,//OTP Modal
            otpValues: ['', '', '', '', '', ''],
            otpTimeLeft: 60,
            otpCanResend: false,
            otpRefCode: '',
            otpMessage: '',
            otpTimerId: null,
            mobileVerified: false,
            otpRunId: '',
            otpMaxError: false,
            registerMsgLanguage: '',
            registerMsgReceive: '',
            registerMsgAgree: '',
            showPopup: false,//BD Modal
            cssBtnOtpCurrent: 'btn btn-gray rounded-pill px-4 text-decoration-none ms-3',
            cssBtnOtp01: 'btn btn-gray rounded-pill px-4 text-decoration-none ms-3',
            cssBtnOtp02: 'btn btn-primary rounded-pill px-4 text-decoration-none ms-3',
            cssBtnSubmitCurrent: 'btn btn-gray rounded-pill px-4 text-decoration-none',
            cssBtnSubmit01: 'btn btn-gray rounded-pill px-4 text-decoration-none',
            cssBtnSubmit02: 'btn btn-primary rounded-pill px-4 text-decoration-none',
            cssEmailUsername: 'fw-semibold text-green-1',

        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        const searchParams = new URLSearchParams(this.props.location.search);
        const codeRegister = searchParams.get('codereg');
        if (!codeRegister) {
            const dataToSend = { reason: "No code!!" };
            this.props.history.replace('/joinnowerr', dataToSend);
            return;
        }

        // Update state and call API to get member information
        this.setState({ codeRegister }, () => {
            this.callApiRegisterInfo(codeRegister);
        });

        {
            // Google analytic
            const documentPath = "Join - detail"; // Gets the current URL path
            const clientId = getClientId(); // Use the getClientId function

            // Push data to the GTM dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'pageview',
                page: documentPath,
                clientId: clientId,
            });
        }
    }

    componentWillUnmount() {
        if (this.state.otpTimerId) {
            clearInterval(this.state.otpTimerId);
        }
    }

    async callApiRegisterInfo(codeRegister) {
        // Add the wait cursor class to the body element
        document.body.classList.add('wait-cursor');

        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        const payload = { codereg: codeRegister, RefLang: "en", Timestamp: timestamp };
        const encryptedPayload = encryptData(payload);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/CrmRegisterStep02`, requestOptions);
            const data = await response.json();

            if (data) {
                if (data.responseCode == "OK") {
                    let cssEmailUsername = "fw-semibold text-green-1";
                    let email = data.responseMessage;

                    if (email.length > 50) {
                        cssEmailUsername = "fw-semibold text-green-1 h6 small";
                    } else if (email.length > 25) {
                        cssEmailUsername = "fw-semibold text-green-1 h6";
                    }

                    this.setState({ memberInfo: data, renderCheck: true, cssEmailUsername: cssEmailUsername }, () => {
                        // Initialize this java after loaded
                        window.$(".toggle-password").click(function () {
                            window.$(this).toggleClass("fa-eye fa-eye-slash");
                            var input = window.$(window.$(this).attr("toggle"));
                            if (input.attr("type") === "password") {
                                input.attr("type", "text");
                            } else {
                                input.attr("type", "password");
                            }
                        });
                    });
                }
                else {
                    const dataToSend = { reason: data.responseMessage };
                    this.props.history.replace('/joinnowerr', dataToSend);
                }
            }
            else {
                const dataToSend = { reason: "No data!!" };
                this.props.history.replace('/joinnowerr', dataToSend);
            }
        } catch (error) {
            console.error('API call error :', error);
        } finally {
            document.body.classList.remove('wait-cursor'); // Remove the wait cursor class
        }
    }

    handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // checkbox
        if (type === "checkbox") {
            if (name === "receiveNews") {
                let css01 = 'mb-3 ps-0 d-none';
                if (checked) {
                    css01 = 'mb-3 ps-0';
                }

                this.setState(
                    { [name]: checked, receiveNewsCss: css01 },
                    () => this.chkEnableBtnSubmit()
                );
            }
            else {
                this.setState(
                    { [name]: checked },
                    () => this.chkEnableBtnSubmit()
                );
            }
            return;
        }

        // radio
        if (type === "radio") {
            this.setState(
                { [name]: value },
                () => this.chkEnableBtnSubmit()
            );
            return;
        }

        // text / number / other inputs
        let newValue = value;
        let errors = "";
        let errorsMobile = "";

        if (name === "mobile") {
            newValue = value.replace(/\D/g, "").slice(0, 10);
            errorsMobile = this.validateMobileNumber(newValue);
        }

        if (name === "password1") {
            errors = validatePassword(newValue);
        }

        let disabledBtnOtp = this.state.disabledBtnOtp;
        let cssBtnOtpCurrent = this.state.cssBtnOtp01;
        if (name === "mobile") {
            if (errorsMobile !== "") {
                disabledBtnOtp = true;
                cssBtnOtpCurrent = this.state.cssBtnOtp01;
            } else {
                disabledBtnOtp = false;
                cssBtnOtpCurrent = this.state.cssBtnOtp02;
            }
        }

        const newState = {
            [name]: newValue,
            registerMsgPwd: errors,
            disabledBtnOtp: disabledBtnOtp,
            cssBtnOtpCurrent: cssBtnOtpCurrent
        };

        if (name === "bdMonth") {
            newState.bdDay = "";
        }

        this.setState(newState, () => this.chkEnableBtnSubmit());
    };

    handleSubmit = async e => {
        e.preventDefault();

        //clear alert text
        this.setState({ registerMsgPwd2: "", registerMsgFname: "", registerMsgLname: "", registerMsgMobile: "", registerMsgLanguage: "", registerMsgReceive: "", registerMsgAgree: "" });

        //260120 block double submit
        //Guard: if already disabledBtnSubmit, ignore
        if (this.state.disabledBtnSubmit) return;
        //Lock immediately (prevents rapid clicks/enter)
        this.setState({ disabledBtnSubmit: true });

        const { memberInfo, password1, password2, prefix, firstname, lastname, firstnameth, lastnameth, mobile, bdDay, bdMonth, agree1, codeRegister, languagePreference, receiveNews, receiveNewsSMS, receiveNewsEmail, mobileVerified } = this.state;

        let canSubmit = true;

        //check form condition
        const errors = validatePassword(password1);
        if (errors) {
            this.setState({ registerMsgPwd: errors });
            canSubmit = false;
        }

        if (password2 === "") {
            this.setState({ registerMsgPwd2: "Please Input Confirm Password." });
            canSubmit = false;
        }

        if (password1 !== password2) {
            this.setState({ registerMsgPwd2: "The password confirmation does not match." });
            canSubmit = false;
        }

        //if (firstname === "") {
        //    this.setState({ registerMsgFname: "Please Input Name" });
        //    canSubmit = false;
        //}
        //if (lastname === "") {
        //    this.setState({ registerMsgLname: "Please Input Lastname" });
        //    canSubmit = false;
        //}

        const errorsEn01 = validateNameEN(firstname);
        if (errorsEn01) {
            this.setState({ registerMsgFname: errorsEn01 });
            canSubmit = false;
        }

        const errorsEn02 = validateLastnameEN(lastname);
        if (errorsEn02) {
            this.setState({ registerMsgLname: errorsEn02 });
            canSubmit = false;
        }

        // Mobile validation
        if (mobile && (!/^0\d{9}$/.test(mobile))) {
            this.setState({ registerMsgMobile: "Please Input valid Mobile number." });
            canSubmit = false;
        }

        // Mobile mobileVerified
        if (mobileVerified == false) {
            this.setState({ registerMsgMobile: "Invalid mobile number." });
            canSubmit = false;
        }

        if (languagePreference === "") {
            this.setState({ registerMsgLanguage: "Please select your language preference." });
            canSubmit = false;
        }

        //if (receiveNews === false) {
        //    this.setState({ registerMsgReceive: "Please select at least one option." });
        //    canSubmit = false;
        //}

        //if (receiveNewsSMS === false && receiveNewsEmail === false) {
        //    this.setState({ registerMsgReceive: "Please select at least one option." });
        //    canSubmit = false;
        //}

        // Only validate channels when user chooses to receive news
        if (receiveNews === true) {
            if (receiveNewsSMS === false && receiveNewsEmail === false) {
                this.setState({ registerMsgReceive: "Please select channels you would like to receive Starbucks promotions and news." });
                canSubmit = false;
            }
        }
        const optInMarketing = receiveNews ? receiveNews : false;
        const optInSMS = receiveNews ? receiveNewsSMS : false;
        const optInEmail = receiveNews ? receiveNewsEmail : false;

        if (agree1 === false) {
            this.setState({ registerMsgAgree: "Please Accept Privacy Policy and Terms of Use." });
            canSubmit = false;
        }

        if (canSubmit == false) {
            //unlock because validation failed
            this.setState({ disabledBtnSubmit: false });
            return;
        }

        //No BirthdayD show popup
        if (bdDay === "") {
            this.setState({ showPopup: true, disabledBtnSubmit: false, submitting: false });
            return;
        }

        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        // Prepare and encrypt the payload
        const payload = { Email: memberInfo.responseMessage, CurrentPassword: password1, RefLang: 'en', Salutation: prefix, FirstName: firstname, LastName: lastname, FirstNameTH: firstnameth, LastNameTH: lastnameth, MobilePhone: mobile, BirthdayD: bdDay, BirthdayM: bdMonth, Agree1: agree1, CodeReg: codeRegister, Timestamp: timestamp, LanguagePreference: languagePreference, OptInMarketing: optInMarketing, OptInSMS: optInSMS, OptInEmail: optInEmail };
        const encryptedPayload = encryptData(payload);

        // Prevent double-clicking by disabling the submit button and changing cursor to 'wait'
        this.setState({ submitting: true });

        // Add the wait cursor class to the body element
        document.body.classList.add('wait-cursor');

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/CrmRegisterStep03`, requestOptions);
            const data = await response.json();

            if (data.responseCode === "OK") {
                document.body.classList.remove('wait-cursor'); // Remove the wait cursor class

                const dataToSend = { responseData: data };
                this.props.history.replace('/joinnowthx', dataToSend);
            }
            else {
                document.body.classList.remove('wait-cursor'); // Remove the wait cursor class

                const dataToSend = { responseData: data };
                this.props.history.replace('/joinnowerr', dataToSend);
            }
        } catch (error) {
            console.error('Error during api:', error);
            // Handle error appropriately, e.g., show an error message to the user
            // Enable the submit button and change cursor back to 'auto' after form submission completes
            this.setState({ submitting: false });
            document.body.classList.remove('wait-cursor'); // Remove the wait cursor class
        } finally {

        }
    };

    handleSubmit2 = async e => {
        ////No Birthday check fo this
        e.preventDefault();

        //clear alert text
        this.setState({ registerMsgPwd2: "", registerMsgFname: "", registerMsgLname: "", registerMsgMobile: "", registerMsgLanguage: "", registerMsgReceive: "", registerMsgAgree: "" });

        //260120 block double submit
        //Guard: if already submitting, ignore
        if (this.state.submitting) return;
        //Lock immediately (prevents rapid clicks/enter)
        this.setState({ submitting: true });

        const { memberInfo, password1, password2, prefix, firstname, lastname, firstnameth, lastnameth, mobile, bdDay, bdMonth, agree1, codeRegister, languagePreference, receiveNews, receiveNewsSMS, receiveNewsEmail, mobileVerified } = this.state;

        let canSubmit = true;

        //check form condition
        const errors = validatePassword(password1);
        if (errors) {
            this.setState({ registerMsgPwd: errors });
            canSubmit = false;
        }

        if (password2 === "") {
            this.setState({ registerMsgPwd2: "Please Input Confirm Password." });
            canSubmit = false;
        }

        if (password1 !== password2) {
            this.setState({ registerMsgPwd2: "The password confirmation does not match." });
            canSubmit = false;
        }

        //if (firstname === "") {
        //    this.setState({ registerMsgFname: "Please Input Name" });
        //    canSubmit = false;
        //}

        //if (lastname === "") {
        //    this.setState({ registerMsgLname: "Please Input Lastname" });
        //    canSubmit = false;
        //}
        const errorsEn01 = validateNameEN(firstname);
        if (errorsEn01) {
            this.setState({ registerMsgFname: errorsEn01 });
            canSubmit = false;
        }

        const errorsEn02 = validateNameEN(lastname);
        if (errorsEn02) {
            this.setState({ registerMsgLname: errorsEn02 });
            canSubmit = false;
        }

        // Mobile validation
        if (mobile && (!/^0\d{9}$/.test(mobile))) {
            this.setState({ registerMsgMobile: "Please Input valid Mobile number." });
            canSubmit = false;
        }

        // Mobile mobileVerified
        if (mobileVerified == false) {
            this.setState({ registerMsgMobile: "Invalid mobile number." });
            canSubmit = false;
        }

        // Only validate channels when user chooses to receive news
        if (receiveNews === true) {
            if (receiveNewsSMS === false && receiveNewsEmail === false) {
                this.setState({ registerMsgReceive: "Please select channels you would like to receive Starbucks promotions and news." });
                canSubmit = false;
            }
        }
        const optInMarketing = receiveNews ? receiveNews : false;
        const optInSMS = receiveNews ? receiveNewsSMS : false;
        const optInEmail = receiveNews ? receiveNewsEmail : false;

        //if (agree1 !== true) {
        //    this.setState({ registerMsgAgree: "Please Accept Email Preference" });
        //    canSubmit = false;
        //}

        if (canSubmit == false) {
            this.setState({ submitting: false });
            return;
        }


        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        // Prepare and encrypt the payload
        const payload = { Email: memberInfo.responseMessage, CurrentPassword: password1, RefLang: 'en', Salutation: prefix, FirstName: firstname, LastName: lastname, FirstNameTH: firstnameth, LastNameTH: lastnameth, MobilePhone: mobile, BirthdayD: bdDay, BirthdayM: bdMonth, Agree1: agree1, CodeReg: codeRegister, Timestamp: timestamp, LanguagePreference: languagePreference, OptInMarketing: optInMarketing, optInSMS: optInSMS, OptInEmail: optInEmail };
        const encryptedPayload = encryptData(payload);

        // Prevent double-clicking by disabling the submit button and changing cursor to 'wait'
        this.setState({ submitting: true });

        // Add the wait cursor class to the body element
        document.body.classList.add('wait-cursor');

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/CrmRegisterStep03`, requestOptions);
            const data = await response.json();

            if (data.responseCode === "OK") {
                document.body.classList.remove('wait-cursor'); // Remove the wait cursor class

                const dataToSend = { responseData: data };
                this.props.history.replace('/joinnowthx', dataToSend);
            }
            else {
                document.body.classList.remove('wait-cursor'); // Remove the wait cursor class

                const dataToSend = { responseData: data };
                this.props.history.replace('/joinnowerr', dataToSend);
            }
        } catch (error) {
            console.error('Error during api:', error);
            // Handle error appropriately, e.g., show an error message to the user
            // Enable the submit button and change cursor back to 'auto' after form submission completes
            this.setState({ submitting: false });
            document.body.classList.remove('wait-cursor'); // Remove the wait cursor class
        } finally {

        }
    };

    cancelSubmit = () => {
        this.setState({ showPopup: false });
    };

    //validatePassword = (password) => {
    //    const minLength = 9;
    //    const maxLength = 15;
    //    const numberRegex = /[0-9]/;
    //    const capitalLetterRegex = /[A-Z]/;
    //    const lowerCaseLetterRegex = /[a-z]/;
    //    const specialCharRegex = /[~!@()#$%^*:;]/;

    //    if (password.length === 0) {
    //        return 'Please Input Password.';
    //    }
    //    if (password.length < minLength || password.length > maxLength) {
    //        return `Password must be between ${minLength} and ${maxLength} characters long. `;
    //    }
    //    if (!numberRegex.test(password)) {
    //        return 'Password must contain at least one number. ';
    //    }
    //    if (!capitalLetterRegex.test(password)) {
    //        return 'Password must contain at least one capital letter. ';
    //    }
    //    if (!lowerCaseLetterRegex.test(password)) {
    //        return 'Password must contain at least one lower case letter. ';
    //    }
    //    if (!specialCharRegex.test(password)) {
    //        return 'Password must contain at least one special character (e.g., !,@,#,$,*,;,&). ';
    //    }

    //    return ''; // Return an empty string if all checks pass
    //};

    validateMobileNumber = (mobile) => {
        const mobileRegex = /^0[0-9]{9}$/; // must start with 0 and total 10 digits

        if (!mobile || mobile.length === 0) {
            return 'Invalid mobile number.';
        }

        if (!mobileRegex.test(mobile)) {
            return 'Invalid mobile number.';
        }

        return ''; // valid
    };

    handleFocus = () => {
        this.setState({ showPasswordTips: true });
    };

    handleBlur = () => {
        this.setState({ showPasswordTips: false });
    };

    //SR2.0
    async callApiSR20OtpStep01(mobile, codeRegister, Source, RefLang, LoyaltyMemberId) {
        document.body.classList.add('wait-cursor');

        const timestamp = Math.floor(Date.now() / 1000);

        const payload = {
            codereg: codeRegister,
            RefLang: RefLang,
            Timestamp: timestamp,
            MobilePhone: mobile,
            Source: Source,
            LoyaltyMemberId: LoyaltyMemberId
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/SR20OtpStep01`, requestOptions);
            const data = await response.json();

            return data;
        } catch (error) {
            console.error('API call error :', error);
            return null;
        } finally {
            document.body.classList.remove('wait-cursor');
        }
    }

    async callApiSR20OtpStep02(mobile, codeRegister, Source, RefLang, LoyaltyMemberId, OtpId, RefCode, Otp) {
        document.body.classList.add('wait-cursor');

        const timestamp = Math.floor(Date.now() / 1000);

        const payload = {
            codereg: codeRegister,
            RefLang: RefLang,
            Timestamp: timestamp,
            MobilePhone: mobile,
            Source: Source,
            LoyaltyMemberId: LoyaltyMemberId,
            OtpId: OtpId,
            RefCode: RefCode,
            Otp: Otp
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/SR20OtpStep02`, requestOptions);
            const data = await response.json();

            return data;
        } catch (error) {
            console.error('API call error :', error);
            return null;
        } finally {
            document.body.classList.remove('wait-cursor');
        }
    }

    handleStep01 = async e => {
        e.preventDefault();

        //260120 block double submit
        //Guard: if already submitting, ignore
        if (this.state.submitting) return;
        //Lock immediately (prevents rapid clicks/enter)
        this.setState({ submitting: true });

        const { password1, password2 } = this.state;

        {
            let canSubmit = true;

            //check form condition
            const errors = validatePassword(password1);
            if (errors) {
                this.setState({ registerMsgPwd: errors });
                canSubmit = false;
            }

            if (password2 === "") {
                this.setState({ registerMsgPwd2: "Please Input Confirm Password." });
                canSubmit = false;
            }

            if (password1 !== password2) {
                this.setState({ registerMsgPwd2: "The password confirmation does not match." });
                canSubmit = false;
            }

            if (canSubmit == false) {
                this.setState({ submitting: false });
                return;
            }
            else {
                this.setState({ currentStep: '2' });
                return;
            }
        }


    };

    openOtpModal = async () => {
        const { mobile, otpTimerId, codeRegister } = this.state;

        const mobileError = this.validateMobileNumber(mobile);
        if (mobileError) {
            this.setState({
                registerMsgMobile: mobileError,
                showOtpModal: false
            });
            return;
        }

        if (otpTimerId) {
            clearInterval(otpTimerId);
        }

        // #region "call API Get OTP"
        const data = await this.callApiSR20OtpStep01(mobile, codeRegister, "Register", "en", "");

        if (data) {
            if (data.responseCode == "OK") {
                this.setState(
                    {
                        showOtpModal: true,
                        otpValues: ['', '', '', '', '', ''],
                        otpTimeLeft: 60,
                        otpCanResend: false,
                        otpMessage: '',
                        otpRefCode: data.returnObj.refCode,
                        otpRunId: data.returnObj.otpId,
                        otpMaxError: false,
                        registerMsgMobile: ''
                    },
                    () => {
                        this.startOtpTimer();

                        if (this.otpInputRefs[0]) {
                            this.otpInputRefs[0].focus();
                        }
                    }
                );
            } else {
                this.setState({ registerMsgMobile: data.responseMessage });
            }
        } else {
            this.setState({ registerMsgMobile: 'An unexpected error occurred on the server. Please try again.' });
        }
        // #endregion
    };

    closeOtpModal = () => {
        if (this.state.otpTimerId) {
            clearInterval(this.state.otpTimerId);
        }

        this.setState({
            showOtpModal: false,
            otpTimerId: null
        });
    };

    startOtpTimer = () => {
        if (this.state.otpTimerId) {
            clearInterval(this.state.otpTimerId);
        }

        const timerId = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.otpTimeLeft <= 1) {
                    clearInterval(timerId);
                    return {
                        otpTimeLeft: 0,
                        otpCanResend: true,
                        otpTimerId: null
                    };
                }

                return {
                    otpTimeLeft: prevState.otpTimeLeft - 1
                };
            });
        }, 1000);

        this.setState({ otpTimerId: timerId });
    };

    formatOtpTime = (sec) => {
        return `00:${String(sec).padStart(2, '0')}`;
    };

    handleOtpChange = (index, event) => {
        const value = event.target.value.replace(/\D/g, '').slice(0, 1);

        this.setState((prevState) => {
            const newOtpValues = [...prevState.otpValues];
            newOtpValues[index] = value;
            return { otpValues: newOtpValues, otpMessage: '' };
        }, () => {
            if (value && index < 5 && this.otpInputRefs[index + 1]) {
                this.otpInputRefs[index + 1].focus();
            }
        });
    };

    handleOtpKeyDown = (index, event) => {
        if (event.key === 'Backspace' && !this.state.otpValues[index] && index > 0) {
            if (this.otpInputRefs[index - 1]) {
                this.otpInputRefs[index - 1].focus();
            }
        }
    };

    handleOtpPaste = (event) => {
        event.preventDefault();

        const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
        const newOtpValues = ['', '', '', '', '', ''];

        pasted.split('').forEach((char, i) => {
            newOtpValues[i] = char;
        });

        this.setState({ otpValues: newOtpValues, otpMessage: '' }, () => {
            const lastIndex = Math.min(pasted.length, 6) - 1;
            if (lastIndex >= 0 && this.otpInputRefs[lastIndex]) {
                this.otpInputRefs[lastIndex].focus();
            }
        });
    };

    handleResendOtp = async () => {
        const { mobile, otpTimerId, codeRegister } = this.state;

        if (otpTimerId) {
            clearInterval(otpTimerId);
        }

        // #region "call API Get OTP"
        const data = await this.callApiSR20OtpStep01(mobile, codeRegister, "Register", "en", "");

        if (data) {
            if (data.responseCode == "OK") {
                this.setState(
                    {
                        showOtpModal: true,
                        otpValues: ['', '', '', '', '', ''],
                        otpTimeLeft: 60,
                        otpCanResend: false,
                        otpMessage: '',
                        otpRefCode: data.returnObj.refCode,
                        otpRunId: data.returnObj.otpId,
                        otpMaxError: false,
                        registerMsgMobile: ''
                    },
                    () => {
                        this.startOtpTimer();

                        if (this.otpInputRefs[0]) {
                            this.otpInputRefs[0].focus();
                        }
                    }
                );
            } else {
                this.setState({ otpMessage: data.responseMessage });
            }
        } else {
            this.setState({ otpMessage: 'An unexpected error occurred on the server. Please try again.' });
        }
        // #endregion
    };

    handleVerifyOtp = async () => {
        const { otpRunId, otpRefCode, otpValues, otpTimerId } = this.state;
        const otpCode = otpValues.join("");

        if (otpCode.length !== 6) {
            this.setState(
                { otpMessage: "Invalid OTP" },
                () => this.chkEnableBtnSubmit()
            );
            return;
        }

        try {
            // #region "call API Verify OTP"
            const data = await this.callApiSR20OtpStep02("", "", "Register", "en", "", otpRunId, otpRefCode, otpCode);

            if (data) {
                if (data.responseCode === "OK") {
                    if (otpTimerId) {
                        clearInterval(otpTimerId);
                    }

                    this.setState({
                        otpMessage: '',
                        showOtpModal: false,
                        otpTimerId: null,
                        mobileVerified: true,
                        otpMaxError: false
                    },
                        () => this.chkEnableBtnSubmit());
                } else {
                    if (data.responseCode === "ErrorMax") {
                        this.setState({ otpMessage: data.responseMessage, otpMaxError: true },
                            () => this.chkEnableBtnSubmit());
                    }
                    else {
                        this.setState(
                            {
                                otpMessage: data.responseMessage,
                                otpMaxError: false
                            },
                            () => this.chkEnableBtnSubmit()
                        );
                    }
                    return;
                }
            } else {
                this.setState({ otpMessage: 'Invalid OTP' },
                    () => this.chkEnableBtnSubmit());
                return;
            }
            // #endregion
        } catch (error) {
            console.error('Verify OTP error:', error);
            this.setState({ otpMessage: 'Verify OTP failed' },
                () => this.chkEnableBtnSubmit());
        }
    };

    chkEnableBtnSubmit = () => {
        const { agree1, cssBtnSubmit01, cssBtnSubmit02 } = this.state;

        let disabledBtnSubmit = false;
        let cssBtnSubmitCurrent = cssBtnSubmit02;

        // check agree1
        if (agree1 === false) {
            disabledBtnSubmit = true;
            cssBtnSubmitCurrent = cssBtnSubmit01;
        }

        this.setState({
            disabledBtnSubmit: disabledBtnSubmit,
            cssBtnSubmitCurrent: cssBtnSubmitCurrent
        });
    };

    //chkEnableBtnSubmit = () => {
    //    const {
    //        password1,
    //        password2,
    //        firstname,
    //        lastname,
    //        mobileVerified,
    //        languagePreference,
    //        receiveNews,
    //        receiveNewsSMS,
    //        receiveNewsEmail,
    //        agree1
    //    } = this.state;

    //    let disabledBtnSubmit = false;
    //    let registerMsgPwd = "";
    //    let registerMsgPwd2 = "";
    //    let registerMsgFname = "";
    //    let registerMsgLname = "";

    //    const errors = this.validatePassword(password1);
    //    if (errors) {
    //        registerMsgPwd = errors;
    //        disabledBtnSubmit = true;
    //    }

    //    if (password2 === "") {
    //        disabledBtnSubmit = true;
    //    } else if (password1 !== password2) {
    //        disabledBtnSubmit = true;
    //    }

    //    if (firstname === "") {
    //        disabledBtnSubmit = true;
    //    }

    //    if (lastname === "") {
    //        disabledBtnSubmit = true;
    //    }

    //    if (mobileVerified === false) {
    //        disabledBtnSubmit = true;
    //    }

    //    if (languagePreference === "") {
    //        disabledBtnSubmit = true;
    //    }

    //    if (receiveNews === false) {
    //        disabledBtnSubmit = true;
    //    }

    //    if (receiveNewsSMS === false && receiveNewsEmail === false) {
    //        disabledBtnSubmit = true;
    //    }

    //    if (agree1 === false) {
    //        disabledBtnSubmit = true;
    //    }

    //    this.setState({
    //        registerMsgPwd,
    //        registerMsgPwd2,
    //        registerMsgFname,
    //        registerMsgLname,
    //        disabledBtnSubmit: disabledBtnSubmit
    //    });
    //};

    render() {
        const { memberInfo, password1, password2, prefix, firstname, lastname, firstnameth, lastnameth, mobile, bdDay, bdMonth, agree1, registerMsg, registerMsgPwd, registerMsgPwd2, registerMsgFname, registerMsgLname, submitting, renderCheck, showPasswordTips, registerMsgAgree, cssPopupBD, registerMsgMobile, currentStep, disabledBtnOtp, disabledBtnSubmit, languagePreference, receiveNews, receiveNewsSMS, receiveNewsEmail, receiveNewsCss, showOtpModal, otpValues, otpTimeLeft, otpCanResend, otpRefCode, otpMessage, mobileVerified, otpMaxError, registerMsgLanguage, registerMsgReceive, showPopup, cssBtnOtpCurrent, cssBtnSubmitCurrent, cssEmailUsername } = this.state;

        const getDaysInMonth = (month) => {
            const daysInMonth = {
                '01': 31, // January
                '02': 29, // February
                '03': 31, // March
                '04': 30, // April
                '05': 31, // May
                '06': 30, // June
                '07': 31, // July
                '08': 31, // August
                '09': 30, // September
                '10': 31, // October
                '11': 30, // November
                '12': 31, // December
            };

            return daysInMonth[month] || 0; // Default to 0 if month is not selected
        };

        const days = Array.from({ length: getDaysInMonth(bdMonth) }, (_, i) => i + 1);

        return (
            <>
                <EnNavHeader />
                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 "><span className="d-none">Starbucks® Rewards</span><img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} /></h1>
                                </div>
                            </div>
                        </div>
                    </section>

                    {memberInfo && renderCheck ? (
                        <>
                            {/* #region Step01 */}
                            {currentStep === "1" && (
                                <section className="section-create-account overflow-hidden pb-5">
                                    <div className="container p-3 p-md-0">
                                        <div className="row">
                                            <div className="col-md-12 mb-5 pt-3 text-start">
                                                <h2 className="h3 mt-5 mb-4 fw-bold text-dark-212121">Create an account</h2>
                                                <form className="form-sr">
                                                    <div className="row">
                                                        <div className="col-md-4 mb-4">
                                                            <label className="form-label d-none">Username.</label>
                                                            <h5 className={cssEmailUsername}>{memberInfo.responseMessage}</h5>
                                                            <div className="form-text">This will be your username.</div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">Enter your password<span className="text-green-1">*</span></label>
                                                            <div className="input-group mb-3">
                                                                <div className="input-group mb-3">
                                                                    <input
                                                                        id="password-field"
                                                                        type="password"
                                                                        className="form-control border-end-0"
                                                                        placeholder="*Password" name="password1"
                                                                        value={password1}
                                                                        onChange={this.handleChange}
                                                                        onFocus={this.handleFocus}
                                                                        onBlur={this.handleBlur}
                                                                    />
                                                                    <span className="input-group-text"><i toggle="input[name='password1']" className="fa fa-fw fa-eye-slash toggle-password" /></span>
                                                                    <div className="invalid-feedback" style={{ display: 'block' }}>{registerMsgPwd}</div>
                                                                    {showPasswordTips && (
                                                                        <div id="new-password-field-tips" className="passwordtips-box">
                                                                            <h4 className="h6 text-decoration-underline">Password Tips</h4>
                                                                            <p className="form-text">
                                                                                Between 9 to 15 characters<br />
                                                                                At least one numerical character<br />
                                                                                At least one uppercase character<br />
                                                                                At least one lowercase character<br />
                                                                                At least one special character ~!@()#$%^*:;<br />
                                                                                No blank space
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">Confirm Password<span className="text-green-1">*</span></label>
                                                            <div className="input-group mb-3">
                                                                <input id="password-confirm-field" type="password" className="form-control border-end-0" placeholder="*Confirm Password" name="password2" value={password2} onChange={this.handleChange} />
                                                                <span className="input-group-text"><i toggle="input[name='password2']" className="fa fa-fw fa-eye-slash toggle-password" /></span>
                                                                <div className="invalid-feedback" style={{ display: 'block' }}>{registerMsgPwd2}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="text-start mt-4">
                                                        <button type="button" className="btn btn-primary rounded-pill px-4 text-decoration-none" onClick={this.handleStep01}>Continue</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )}
                            {/* #endregion */}

                            {/* #region Step02 */}
                            {currentStep === "2" && (
                                <section className="section-create-account overflow-hidden pb-5">
                                    <div className="container p-3 p-md-0">
                                        <div className="row">
                                            <div className="col-md-12 mb-5 pt-3 text-start">
                                                <h2 className="h3 mt-5 mb-4 fw-bold text-dark-212121">Create an account</h2>
                                                <form className="form-sr" autoComplete="off">
                                                    <div className="row">
                                                        <div className="col-md-4 mb-4">
                                                            <label className="form-label d-none">Username.</label>
                                                            <h5 className={cssEmailUsername}>{memberInfo.responseMessage}</h5>
                                                            <div className="form-text">This will be your username.</div>
                                                        </div>
                                                    </div>
                                                    <h4 className="h4 mt-4 mb-3"><strong>Personal Particular</strong></h4>
                                                    <div className="row">
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">Prefix (optional)</label>
                                                            <select className="form-select" name="prefix" value={prefix} onChange={this.handleChange}>
                                                                <option value="">Please select</option>
                                                                <option value="Mr.">Mr. </option>
                                                                <option value="Mrs.">Mrs. </option>
                                                                <option value="Ms">Ms </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">Name (English) <span className="text-green-1">*</span></label>
                                                            <input type="text" className="form-control" placeholder="Name (English)" name="firstname" value={firstname} onChange={this.handleChange} />
                                                            <div className="text-start mt-1 text-alert-2">
                                                                {registerMsgFname}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">Last Name (English) <span className="text-green-1">*</span></label>
                                                            <input type="text" className="form-control" placeholder="Last Name (English)" name="lastname" value={lastname} onChange={this.handleChange} />
                                                            <div className="text-start mt-1 text-alert-2">
                                                                {registerMsgLname}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">ชื่อ ภาษาไทย (ไม่จำเป็นต้องระบุ)</label>
                                                            <input type="text" className="form-control" placeholder="ชื่อภาษาไทย (ไม่จำเป็นต้องระบุ)" name="firstnameth" value={firstnameth} onChange={this.handleChange} />
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">นามสกุล ภาษาไทย (ไม่จำเป็นต้องระบุ)</label>
                                                            <input type="text" className="form-control" placeholder="นามสกุลภาษาไทย (ไม่จำเป็นต้องระบุ)" name="lastnameth" value={lastnameth} onChange={this.handleChange} />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <p className="h6">Birthday (optional)<br />
                                                                <span className="small">Make your birthday special once you reach Gold level with a reward on us.</span></p>
                                                            <div className="row g-3">
                                                                <div className="col-md-3 mb-3">
                                                                    <select className="form-select" name="bdMonth" value={bdMonth} onChange={this.handleChange}>
                                                                        <option value="">Month</option>
                                                                        <option value="01">Jan</option>
                                                                        <option value="02">Feb</option>
                                                                        <option value="03">Mar</option>
                                                                        <option value="04">Apr</option>
                                                                        <option value="05">May</option>
                                                                        <option value="06">Jun</option>
                                                                        <option value="07">Jul</option>
                                                                        <option value="08">Aug</option>
                                                                        <option value="09">Sep</option>
                                                                        <option value="10">Oct</option>
                                                                        <option value="11">Nov</option>
                                                                        <option value="12">Dec</option>
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-3 mb-3">
                                                                    <select className="form-select" name="bdDay" value={bdDay} onChange={this.handleChange}>
                                                                        <option value="">Day</option>
                                                                        {days.map((day) => (
                                                                            <option key={day} value={day}>
                                                                                {day}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-12 col-md-4 mb-3">
                                                            <label className="form-label">Mobile Number <span className="text-green-1">*</span></label>
                                                            <div className="input-group mb-3">
                                                                <input
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    className={`form-control rounded ${mobileVerified ? 'is-valid' : ''}`}
                                                                    name="mobile"
                                                                    value={mobile}
                                                                    onChange={this.handleChange}
                                                                    maxLength={10}
                                                                    readOnly={mobileVerified}
                                                                    autoComplete="block-auto-mobile"
                                                                />

                                                                {!mobileVerified && (
                                                                    <button
                                                                        type="button"
                                                                        className={cssBtnOtpCurrent}
                                                                        disabled={disabledBtnOtp}
                                                                        onClick={this.openOtpModal}
                                                                    >
                                                                        Get OTP
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <div className="text-start mt-1 text-alert-2">
                                                                {registerMsgMobile}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <hr className="mt-2 mb-3" />
                                                        </div>
                                                    </div>

                                                    <div className="row form-check-term">
                                                        <div className="col-md-12 mb-3">
                                                            <p className="fw-bold mb-3">
                                                                <label className="form-label fw-medium d-block mb-3 fs-6"><strong>Preference &amp; Terms</strong></label>
                                                            </p>

                                                            {/* Language Preference (RADIO) */}
                                                            <div className="mb-3">
                                                                <label className="form-label fw-medium d-block">
                                                                    Preferred language for communication updates <span class="text-success">*</span>
                                                                </label>
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        className="form-check-input lang-radio"
                                                                        type="radio"
                                                                        name="languagePreference"
                                                                        id="lang-en"
                                                                        value="en"
                                                                        checked={this.state.languagePreference === "en"}
                                                                        onChange={this.handleChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="lang-en">English</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        className="form-check-input lang-radio"
                                                                        type="radio"
                                                                        name="languagePreference"
                                                                        id="lang-th"
                                                                        value="th"
                                                                        checked={this.state.languagePreference === "th"}
                                                                        onChange={this.handleChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="lang-th">ไทย</label>
                                                                </div>
                                                                <div className="text-danger mt-1 fs-6" id="lang-error">
                                                                    {registerMsgLanguage}
                                                                </div>
                                                            </div>

                                                            {/* Sign up promotions */}
                                                            <div className="mb-3">
                                                                <div className="form-check">
                                                                    <input type="checkbox" className="form-check-input channel-checkbox" name="receiveNews" checked={receiveNews}
                                                                        onChange={this.handleChange} />
                                                                    <label className="form-check-label d-block d-md-inline" htmlFor="promo-checkbox">
                                                                        Sign up to receive exclusive Starbucks promotions and news.<span className="text-success">*</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            {/* Preferred channel */}
                                                            <div className={receiveNewsCss}>
                                                                <p className="fw-normal mb-2 fs-6">I prefer to receive updates via:</p>
                                                                <div className="form-check form-check-inline">
                                                                    <input type="checkbox" className="form-check-input channel-checkbox" name="receiveNewsEmail" checked={receiveNewsEmail}
                                                                        onChange={this.handleChange} />
                                                                    <label className="form-check-label" htmlFor="channel-email">Email</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input type="checkbox" className="form-check-input channel-checkbox" name="receiveNewsSMS" checked={receiveNewsSMS}
                                                                        onChange={this.handleChange} />
                                                                    <label className="form-check-label" htmlFor="channel-sms">SMS</label>
                                                                </div>
                                                                <div className="text-danger mt-1 fs-6">
                                                                    {registerMsgReceive}
                                                                </div>
                                                            </div>

                                                            {/* Agree terms */}
                                                            <div className="mb-4">
                                                                <div className="form-check">
                                                                    <input type="checkbox" className="form-check-input" name="agree1" checked={agree1}
                                                                        onChange={this.handleChange} />
                                                                    <label className="form-check-label d-block d-md-inline" htmlFor="agree-terms">
                                                                        I agree to the Starbucks <a href="https://www.starbucks.co.th/online-policies/privacy-notice/" target="_blank">Privacy Policy</a> and <a href="https://rewards.starbucks.co.th/termsofuse" target="_blank">Terms of Use</a>.
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="text-danger mt-1 fs-6">
                                                                {registerMsgAgree}
                                                            </div>
                                                            <p className="font-15px"><span class="text-green-1">*</span> You can update your preferences on the Starbucks website through your member profile page.</p>
                                                            {/* Submit */}
                                                            <button
                                                                className={cssBtnSubmitCurrent}
                                                                id="submit-btn"
                                                                disabled={disabledBtnSubmit}
                                                                onClick={this.handleSubmit}
                                                            >
                                                                Create an account
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                    {/*Modal OTP*/}
                                    {showOtpModal && (
                                        <>
                                            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                                <div className="modal-dialog modal-fullscreen">
                                                    <div className="modal-content justify-content-center">
                                                        <div className="container">
                                                            <div className="row justify-content-center">
                                                                <div className="col-12 col-md-6">
                                                                    <div className="modal-header border-bottom-0">
                                                                        <h1 className="modal-title fs-5">Enter Verification Code</h1>
                                                                        <button
                                                                            type="button"
                                                                            className="btn-close"
                                                                            onClick={this.closeOtpModal}
                                                                        ></button>
                                                                    </div>

                                                                    <div className="modal-body">
                                                                        <p>Please enter the 6-digit code sent to {mobile}</p>

                                                                        <div className="row g-2 mb-3">
                                                                            <div className="col-auto d-flex gap-2">
                                                                                {otpValues.map((value, index) => (
                                                                                    <input
                                                                                        key={index}
                                                                                        ref={(el) => (this.otpInputRefs[index] = el)}
                                                                                        type="text"
                                                                                        inputMode="numeric"
                                                                                        maxLength="1"
                                                                                        className="form-control form-control-lg text-center rounded-2 px-2 py-3 otp-input"
                                                                                        style={{ width: '56px' }}
                                                                                        value={value}
                                                                                        onChange={(e) => this.handleOtpChange(index, e)}
                                                                                        onKeyDown={(e) => this.handleOtpKeyDown(index, e)}
                                                                                        onPaste={this.handleOtpPaste}
                                                                                    />
                                                                                ))}
                                                                            </div>
                                                                        </div>

                                                                        <p className="fw-medium">
                                                                            Ref. Code: <span className="text-green-1">{otpRefCode}</span>
                                                                        </p>

                                                                        {otpMessage && (
                                                                            <p className="text-alert-2">{otpMessage}</p>
                                                                        )}

                                                                        {!otpCanResend ? (
                                                                            <p className="fw-medium">
                                                                                {!otpMaxError && (
                                                                                    <>
                                                                                        Resend code in{" "}
                                                                                        <span className="text-muted">
                                                                                            <strong>{this.formatOtpTime(otpTimeLeft)}</strong>
                                                                                        </span>
                                                                                    </>
                                                                                )}

                                                                            </p>
                                                                        ) : (
                                                                            <p>
                                                                                {!otpMaxError && (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-link p-0 fw-medium text-green-1 text-decoration-underline"
                                                                                        onClick={this.handleResendOtp}
                                                                                    >
                                                                                        Resend code
                                                                                    </button>
                                                                                )}
                                                                            </p>
                                                                        )}

                                                                        <div className="mt-4 d-flex gap-2">
                                                                            {!otpMaxError && (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary rounded-pill px-4"
                                                                                    onClick={this.handleVerifyOtp}
                                                                                >
                                                                                    Verify OTP
                                                                                </button>
                                                                            )}

                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-secondary rounded-pill px-4 d-none"
                                                                                onClick={this.closeOtpModal}
                                                                            >
                                                                                Close
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="modal-backdrop fade show"></div>
                                        </>
                                    )}

                                    {/*Modal BD*/}
                                    {/*<div className={showPopup ? "popup" : "popuphide"}>*/}
                                    {/*    <div className="modal fade show d-block" id="BirthdayModal" tabIndex={-1}>*/}
                                    {/*        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">*/}
                                    {/*            <div className="modal-content">*/}
                                    {/*                <div className="modal-header">*/}
                                    {/*                    <h1 className="modal-title fs-5">You’ll miss birthday reward?</h1>*/}
                                    {/*                </div>*/}

                                    {/*                <div className="modal-body">*/}
                                    {/*                    <p>*/}
                                    {/*                        Birthday rewards are one of the perks for Gold level members.*/}
                                    {/*                    </p>*/}
                                    {/*                </div>*/}

                                    {/*                <div className="modal-footer">*/}
                                    {/*                    <button*/}
                                    {/*                        className="btn btn-primary"*/}
                                    {/*                        onClick={this.handleSubmit2}*/}
                                    {/*                    >*/}
                                    {/*                        Yes*/}
                                    {/*                    </button>*/}

                                    {/*                    <button*/}
                                    {/*                        className="btn btn-secondary"*/}
                                    {/*                        onClick={this.cancelSubmit}*/}
                                    {/*                    >*/}
                                    {/*                        No*/}
                                    {/*                    </button>*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                    <div className={showPopup ? "popup" : "popuphide"}>
                                        <div className="modal fade show d-block" id="BirthdayModal" tabIndex={-1}>
                                            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">

                                                <div className="modal-content">

                                                    {/* Header */}
                                                    <div className="modal-header border-bottom-0">
                                                        <button
                                                            type="button"
                                                            className="btn-close"
                                                            onClick={this.cancelSubmit}
                                                        />
                                                    </div>

                                                    {/* Body */}
                                                    <div className="modal-body px-5 text-center">
                                                        <h3 className="text-green-1 fw-bold">
                                                            You’ll miss birthday reward?
                                                        </h3>

                                                        <h5 className="fw-bold lh-base">
                                                            Birthday rewards are one of the perks for Gold level members.
                                                            Are you sure you want to leave your birthday blank?
                                                        </h5>
                                                    </div>

                                                    {/* Footer */}
                                                    <div className="modal-footer border-top-0 justify-content-center mb-4">

                                                        <button
                                                            type="button"
                                                            className="btn btn-primary rounded-5 px-4"
                                                            style={{ minWidth: "86px" }}
                                                            onClick={this.handleSubmit2}
                                                        >
                                                            Yes
                                                        </button>

                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary rounded-5 px-4"
                                                            style={{ minWidth: "86px" }}
                                                            onClick={this.cancelSubmit}
                                                        >
                                                            No
                                                        </button>

                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </section>

                            )}
                            {/* #endregion */}
                        </>
                    ) : (
                        <>
                            {/*Loading*/}
                            <div className="col-md-5">
                                <div className="text-center" style={{ height: '160px' }} />
                                <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                    <h3 className="text-white">LOADING ...</h3>
                                    <img src="media/loading-gif.gif" alt="Loading..." width={80} className="img-fluid" />
                                </div>
                                <div style={{ height: '100px' }} />
                            </div>
                        </>
                    )}
                </main>
                <EnNavFooter />
            </>
        );
    }
}

export const EnAuthJoinDetail20 = withRouter(EnAuthJoinDetail20Class);